module.exports = __webpack_public_path__ + "img/htkj_16.69dbad26.jpg";